import React from "react";
import { CATEGORIES } from "../../shared/constants/rolesCategories";

const OrderConfirmedHeader = ({
  isLabOG,
  promoCode,
  labName,
  dadosEmpresaFaturamento,
  userSessionNomeEmpresa,
  userSessionPapelCategoria,
  dadosEmpresaFaturamentoCnpj,
}) => {
  const title = isLabOG ? "Seu pedido foi registrado" : "Seu pedido foi confirmado";
  const successMessage = promoCode
    ? "Parabéns! Você resgatou o seu cupom promocional."
    : "Parabéns! Você completou seu pedido.";

  const isLaboratorio =
    userSessionPapelCategoria === CATEGORIES.LABORATORIO ||
    userSessionPapelCategoria === CATEGORIES.LAB_INDEPENDENTE;

  const showAdditionalMessage =
    promoCode ||
    (isLaboratorio && dadosEmpresaFaturamentoCnpj);

  const nomeOtica = dadosEmpresaFaturamento || userSessionNomeEmpresa || "sua ótica";

  return (
    <>
      <h1 className="x-order-confirmed__title">{title}</h1>

      <p className="x-order-confirmed__paragraph">{successMessage}</p>

      {showAdditionalMessage && ( 
      <p
        className="x-order-confirmed__paragraph"
        style={{ wordBreak: "break-word", marginTop: "40px" }}
      >
        Seu pedido foi enviado ao Laboratório <strong style={{ margin: "0 5px" }}>{labName}</strong>
        {userSessionPapelCategoria !== "OTICA" && (
          <>
            em nome da ótica
            <strong style={{ marginLeft: "5px" }}>{nomeOtica}</strong>
          </>
        )}
      </p>
      )}
    </>
  );
};

export default OrderConfirmedHeader;